export const D_INV01RP = "d_inv01rp";
export const D_INV026 = "d_inv026";
export const D_INV170 = "d_inv170";
export const DISPLAY = "display";
export const PROD_PLANO = "prod_plano";
export const TOKEN = "token";
export const USER = "user";
export const USERNAME = "userName";
export const USER_PREFERENCES = "userPreferences";